<template>
    <v-container>
        <module-bar :title="title" />
        <v-card outlined>
            <v-card-title v-if="schema == 'edit'">
                <v-spacer />
                <v-btn text color="primary" @click="openDialogMissionFiles">ver historial de archivos</v-btn>
            </v-card-title>
            <v-card-text>
                <v-form v-model="valid" ref="formMission">
                    <v-row>
                        <v-col cols="12" md="12">
                            <v-text-field label="Apodo" v-model="avatar" :rules="rulesAvatar" />
                        </v-col>
                        <v-col cols="12">
                            <v-textarea outlined label="Direccion" v-model="address" :rules="rulesAddress" />
                        </v-col>
                        <v-col cols="12">
                            <v-textarea outlined label="Descripcion" v-model="description" :rules="rulesDescription" />
                        </v-col>

                        <v-col cols="12" md="12" v-if="schema == 'edit'">
                            <v-switch v-model="enabled" :label="labelStatus" @change="changeStatus" />
                        </v-col>

                        <v-col cols="12" md="12" v-if="!enabled">
                            <v-textarea :rules="rulesDetails" label="Describa porque se deshabilito la mision" outlined
                                v-model="details" />
                        </v-col>

                        <v-col cols="12" md=12>
                            <span>ARCHIVOS ADJUNTOS</span>
                            <dynamic-file-upload @filesImput="handleUploadSuccess"
                                :clearFiles="clearFiles"></dynamic-file-upload>
                        </v-col>
                    </v-row>
                </v-form>
                <v-alert class="mt-4" type="info">Subir multiples archivos demora algunos minutos, al presionar guardar
                    o editar debes esperar sin presionar algun boton o salir del formulario.</v-alert>
            </v-card-text>
            <v-card-actions>
                <v-btn :laoding="loadingDeleteMission" v-if="schema == 'edit'" color="red" text
                    @click="deleteMission">Eliminar Mision</v-btn>
                <v-spacer />
                <v-btn text v-if="schema == 'edit'" @click="closeDialogMission">cancelar</v-btn>
                <v-btn :loading="loadingProcess" @click="processMission" text color="primary">
                    {{ schema == "new" ?
                        "GUARDAR" : "EDITAR"
                    }}
                </v-btn>
            </v-card-actions>
        </v-card>


        <!-- dialog files -->
        <v-dialog v-model="dialogMissionFiles" width="800" v-if="schema == 'edit'">
            <v-card>
                <v-card-title>HISTORIAL DE ARCHIVOS</v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col v-for="(file, index) in mission.files" :key="index" cols="12" md="6">
                            <v-card outlined width="100%">
                                <v-card-title>
                                    <span>{{ file.created_at }}</span>
                                </v-card-title>
                                <v-card-text>
                                    <div class="preview">
                                        <v-img v-if="file.type.startsWith('image/')" :src="file.file"
                                            :lazy-src="file.file_thumb" alt="Preview" class="preview-image">
                                            <template v-slot:placeholder>
                                                <v-row class="fill-height ma-0" align="center" justify="center">
                                                    <v-progress-circular indeterminate
                                                        color="primary lighten-5"></v-progress-circular>
                                                </v-row>
                                            </template>
                                        </v-img>
                                        <video v-else-if="file.type.startsWith('video/')" controls
                                            class="preview-video">
                                            <source :src="file.file" :type="file.type">
                                        </video>
                                    </div>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer />
                                    <v-btn text color="red" @click="deletePhoto(file, index)"
                                        :loading="loadingDelete && indexClicked === index">Eliminar</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>

            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import ModuleBar from "../General/ModuleBar.vue";
import DynamicFileUpload from "../../components/Forms/dynamicFileUpload.vue";


export default {
    components: { ModuleBar, DynamicFileUpload },
    props: ["schema", "title", "click", "mission"],

    beforeMount() {
        if (this.schema == "edit") {
            this.loadInfo();
        }
    },

    data() {
        return {
            loadingDeleteMission: false,
            labelStatus: "MISION HABILITADA",
            enabled: true,
            details: "",
            indexClicked: -1,
            loadingDelete: false,
            dialogMissionFiles: false,
            clearFiles: 0,
            valid: false,
            loadingProcess: false,
            avatar: "",
            address: "",
            description: "",
            filesUpload: [],
            rulesAvatar: [
                (value) => (value && value.length > 0) || "Ingrese el apodo",
            ],
            rulesAddress: [
                (value) => (value && value.length > 0) || "Ingrese la direccion",
            ],
            rulesDescription: [
                (value) => (value && value.length > 0) || "Ingrese la descripcion",
            ],
            rulesDetails: [
                (value) => (value && value.length > 0) || "Ingrese el motivo de deshabilitacion",
            ],
        };
    },


    watch: {
        avatar(value) {
            this.avatar = value.toUpperCase();
        },

        click() {
            this.loadInfo();
        }
    },

    methods: {
        handleUploadSuccess(uploadedFiles) {
            this.filesUpload = uploadedFiles;
        },

        processMission() {
            if (this.valid) {
                this.loadingProcess = true;

                setTimeout(() => {
                    let payload = new FormData();
                    payload.append("avatar", this.avatar);
                    payload.append("address", this.address);
                    payload.append("description", this.description);
                    payload.append("enabled", this.enabled ? 1 : 0);
                    payload.append("details", this.details);

                    this.filesUpload.forEach((file, index) => {
                        payload.append(`files[${index}]`, file.file);
                    });

                    if (this.schema == "edit") {
                        payload.append("id", this.mission.id);
                    }

                    let path = this.schema == "new" ? "storeMissionAction" : "updateMissionAction";

                    this.$store
                        .dispatch(path, payload)
                        .then((res) => {
                            this.loadingProcess = false;
                            if (this.schema == "edit") {
                                this.avatar = res.avatar;
                                this.address = res.address;
                                this.description = res.description;
                                this.mission.files = res.files;
                                this.$emit("updateMission", res);
                            }
                            this.clear();
                        })
                        .catch(() => {
                            this.loadingProcess = false;
                        });
                }, 500);
            } else {
                this.$refs.formMission.validate();
            }
        },

        clear() {
            if (this.schema == "new") {
                this.avatar = "";
                this.address = "";
                this.description = "";
            }
            this.filesUpload = [];
            this.clearFiles++;
            this.loadingDelete = false;
            this.$refs.formMission.resetValidation();
        },

        loadInfo() {
            this.enabled = this.mission.enabled;
            this.details = this.mission.details;
            this.avatar = this.mission.avatar;
            this.address = this.mission.address;
            this.description = this.mission.description;
        },

        openDialogMissionFiles() {
            this.dialogMissionFiles = true;
        },

        deletePhoto(file, index) {
            this.$confirm({
                message: `Quieres eliminar este archivo, no podra recuperarlo despues de eliminar?`,
                button: {
                    no: "No",
                    yes: "Si",
                },
                callback: (confirm) => {
                    if (confirm) {
                        this.indexClicked = index;
                        this.loadingDelete = true;
                        setTimeout(() => {
                            this.$store
                                .dispatch("deleteMissionFileAction", file)
                                .then(() => {
                                    this.loadingDelete = false;
                                    this.dialogCategory = false;
                                    this.mission.files.splice(index, 1);
                                });
                        }, 500);
                    }
                },
            });

        },

        closeDialogMission() {
            this.$emit("closeDialogMission");
        },

        changeStatus() {
            this.labelStatus = this.enabled ? "MISION HABILITADA" : "MISION DESHABILITADA";

        },

        deleteMission() {
            this.$confirm({
                message: `Quieres eliminar esta mision, no podra recuperarla despues de eliminar?`,
                button: {
                    no: "No",
                    yes: "Si",
                },
                callback: (confirm) => {
                    if (confirm) {
                        this.loadingDeleteMission = true;
                        this.$store
                            .dispatch("deleteMissionAction", { id: this.mission.id })
                            .then(() => {
                                this.loadingDeleteMission = false;
                                this.$emit("deleteMission", { id: this.mission.id });
                            });
                    }
                },
            });
        }

    },
};
</script>

<style scoped>
.preview {
    margin-top: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.preview-image {
    display: block;
    margin: 0 auto;
    max-width: 100%;
    max-height: 100%;
    background-color: silver;
}

.preview-video {
    display: block;
    margin: 0 auto;
    max-width: 100%;
    max-height: 400px;
}
</style>